import axios from 'axios';
import { PIGSPIN_BO_API_URL } from '../../models/buildtime-constant';

export const pigspinBackofficeApiInstance = axios.create({
  baseURL: PIGSPIN_BO_API_URL,
  timeout: 15000,
  timeoutErrorMessage: 'timeout',
});
